import Vue from 'vue'
import pigletTypeFormatter from "@/components/formatter/pigletTypeFormatter";

Vue.filter('pigletType', function (value) {
  if(value === undefined) return '';

  return pigletTypeFormatter.format(value);
})
